import { Sparkles } from 'lucide-react';
import { DEFAULT_STAPLES } from '../domain/staples';
import { labelName } from '../domain/taxonomy';
import { joinNatural } from '../domain/text';
import { useStore } from '../state/store';

/**
 * Without cupboard basics (salt, oil...) almost no recipe counts as makeable, so "meals you can make"
 * looks empty. We never assume them; this asks once, with one tap, and it can be undone.
 */
export function BasicsNudge() {
  const staples = useStore((s) => s.profile.staples);
  const updateProfile = useStore((s) => s.updateProfile);
  const showToast = useStore((s) => s.showToast);
  if (staples.length) return null;
  const add = () => {
    updateProfile({ staples: DEFAULT_STAPLES });
    showToast('Cupboard basics added', { action: { label: 'Undo', run: () => updateProfile({ staples: [] }) } });
  };
  return (
    <section className="tile flex items-start gap-3 p-4 mb-6" aria-labelledby="basics-q">
      <Sparkles size={22} className="text-primary shrink-0 mt-0.5" aria-hidden />
      <div className="flex-1">
        <h2 id="basics-q" className="text-headline">Do you keep the usual basics?</h2>
        <p className="text-subhead text-fg-muted mt-0.5">{joinNatural(DEFAULT_STAPLES.map(labelName).map((x) => x.toLowerCase()))}. Most recipes need a few of these.</p>
        <button className="btn btn-sm btn-primary mt-3" onClick={add}>Yes, I have these</button>
      </div>
    </section>
  );
}
